import api from 'api'

export type IndeedFlexCompany = {
  id: number
  name: string
}

export type IndeedFlexClient = {
  ifClientId: number
  name: string
  ifPlatformId: number
  requiresCertificationType: boolean
  companies: IndeedFlexCompany[]
}

export type ListIndeedFlexClientsResponse = {
  items: IndeedFlexClient[]
}

export const listIndeedFlexClients =
  async (): Promise<ListIndeedFlexClientsResponse> => {
    const response = await api.get<ListIndeedFlexClientsResponse>(
      '/admin/indeed_flex/clients'
    )
    return response.data
  }
